if (typeof p80 === typeof undefined) {
	var p80 = {};
}

p80.predictiveSearch = function (config) {
	/****
	 *
	 * USAGE:
	 *
	 * const p80PredictiveSearch = new p80.predictiveSearch(
	 *  {
	 *      resultsLimit: 5,
	 *      targetElement: "your-search-form-identifier"
	 *      searchDelay: 300
	 *  }
	 * );
	 *
	 *
	 */

	/****
	 *
	 * CONFIGURATION
	 *
	 * {
	 *      resultsLimit: int || 5, // How many results to fetch from the endpoint
	 *      targetElement: string || "header__search-form", // The identifier of your form
	 *      searchDelay: int || 300, // The debounce timer we will wait for after user keystrokes before queing a search
	 * }
	 *
	 */

	this.config = {};
	// Holds how many results to fetch from the endpoint
	this.config.resultsLimit = config && config.resultsLimit ? config.resultsLimit : 5;
	// Our main search wrapper
	this.config.targetElement =
		config && config.targetElement ? config.targetElement : 'header__search-form';
	this.config.targetElement = this.findTargetElement();
	if (!this.config.targetElement || this.config.targetElement === undefined) {
		console.error('No target element found.');
		return;
	}
	// Position our search form relatively so we can absolutely position our results
	// this.config.targetElement.style.position = "relative";
	// Our search input
	this.config.searchInput = this.config.targetElement.querySelectorAll('input[type=search]');
	if (!this.config.searchInput || this.config.searchInput === undefined) {
		console.error('No search input found.');
		return;
	}
	this.config.searchInput = this.config.searchInput[0];
	this.config.form = this.config.searchInput.closest('form');
	// Our timeout that determines how long after an input we wait to search
	this.config.searchDelay = config && config.searchDelay ? config.searchDelay : 300;
	// Holds our search timeout so we can set/clear based on sequential inputs
	this.searchTimer = null;
	// Holds our search results
	this.searchResults = [];
	// Holds our loading indicator HTML once generated
	this.loader = null;
	// Holds our results HTML once generated
	this.resultsList = null;
	this.previousSearch = null;

	this.bind();
	this.generateLoader();
};
// Helper function to find our target element for appending markup
p80.predictiveSearch.prototype.findTargetElement = function () {
	/****
	 *
	 * Target Finding priority:
	 *
	 * ID
	 * Class - Taking first result
	 * Data Attributes - Taking first result
	 *
	 */
	const search = this;
	// Find by ID
	let target = document.getElementById(search.config.targetElement);
	// Find by Class
	if (!target) {
		target = document.getElementsByClassName(search.config.targetElement);
		if (target) {
			target = target[0];
		}
	}
	// Find by Attribute
	if (!target) {
		target = document.querySelector(`[${search.config.targetElement}]`);
	}

	// Return our target if found
	return target ? target : null;
};
p80.predictiveSearch.prototype.bind = function () {
	const search = this;
	search.config.searchInput.addEventListener('keyup', function (e) {
		// Clear our previous search timer
		if (search.searchTimer) clearTimeout(search.searchTimer);
		// Assign our search keyword
		search.searchKeyword = e.target.value;
		// Don't bother setting a search query for empty values
		if (!search.searchKeyword) {
			search.hideLoader();
			search.removeResults();
			return;
		}
		if (
			e.code === 13 ||
			(e.code == 'Enter' && search.searchKeyword != '') ||
			(e.key == 'Enter' && search.searchKeyword != '')
		) {
			search.config.targetElement.submit();
			return;
		}
		if (search.searchKeyword == search.previousSearch) return;
		// Set a new search timer
		search.searchTimer = setTimeout(function () {
			search.search();
		}, search.config.searchDelay);
	});
	// Hide our search on outside clicks
	document.addEventListener('click', function (e) {
		if (
			e.target !== search.config.targetElement &&
			!search.config.targetElement.contains(e.target) &&
			search.resultsList
		) {
			search.removeResults();
			search.hideLoader();
			removeTrapFocus(search.config.form);
		}
	});
};
// Search the suggestions endpoint without keyword input
p80.predictiveSearch.prototype.search = function () {
	const search = this;
	// Double check we have a search value set
	if (!search.searchKeyword) return;
	search.showLoader();
	// Remove previous results if they exists
	if (search.resultsList) search.removeResults();
	fetch(
		`/search/suggest.json?q=${search.searchKeyword}&resources[type]=product&resources[limit]=${search.config.resultsLimit}&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode`
	)
		.then((response) => response.json())
		.then((data) => {
			if (data.resources && data.resources.results && data.resources.results.products) {
				// Assign our search results and generate the list
				search.searchResults = data.resources.results.products;
				search.previousSearch = search.searchKeyword;
				search.generateResults();
			} else {
				search.hideLoader();
				console.error(`Error searching.`);
			}
		})
		.catch((error) => {
			search.hideLoader();
			console.error(`Error searching: ${error}`);
		});
};
// Create the search results markup
p80.predictiveSearch.prototype.generateResults = function () {
	const search = this;
	if (!search.searchResults) return;

	const resultsWrapper = document.createElement('div');
	resultsWrapper.classList.add('predictive-search__results');

	const resultsHeading = document.createElement('h4');
	resultsHeading.classList.add('predictive-search__results-title');
	resultsHeading.innerText = 'Products';

	resultsWrapper.appendChild(resultsHeading);

	for (var x = 0; x < search.searchResults.length; x++) {
		const resultsList = document.createElement('ul');
		resultsList.classList.add('predictive-search__list');

		const resultsListItem = document.createElement('li');
		resultsListItem.classList.add('predictive-search__item');

		const resultsListLink = document.createElement('a');
		resultsListLink.href = search.searchResults[x].url;
		resultsListLink.classList.add('predictive-search__item-link');

		let resultsListImage = document.createElement('div');
		if (search.searchResults[x].featured_image) {
			resultsListImage = document.createElement('img');
			resultsListImage.src = search.searchResults[x].featured_image.url;
			resultsListImage.alt = search.searchResults[x].featured_image.alt;
			resultsListImage.width = '40';
			resultsListImage.height = '40';
		}
		resultsListImage.classList.add('predictive-search__item-image');

		const resultsListTitle = document.createElement('p');
		resultsListTitle.classList.add('predictive-search__item-title');
		// Trim our title over a certain character length
		let trimmedTitle = search.searchResults[x].title;
		if (trimmedTitle.length > 25) {
			trimmedTitle = trimmedTitle.substring(0, 25);
			trimmedTitle = `${trimmedTitle}...`;
		}
		resultsListTitle.innerText = trimmedTitle;

		resultsListLink.appendChild(resultsListImage);
		resultsListLink.appendChild(resultsListTitle);
		resultsListItem.appendChild(resultsListLink);
		resultsList.appendChild(resultsListItem);
		resultsWrapper.appendChild(resultsList);
	}

	const resultsFooter = document.createElement('div');
	resultsFooter.classList.add('predictive-search__results-footer');

	const resultsFooterButton = document.createElement('input');
	resultsFooterButton.setAttribute('type', 'submit');

	resultsFooterButton.classList.add('predictive-search__results-footer__search');
	resultsFooterButton.value = `Search for "${search.searchKeyword}"`;

	const resultsFooterArrow = document.createElement('span');
	resultsFooterArrow.classList.add('predictive-search__results-arrow');
	resultsFooterArrow.innerHTML = '&rarr;';

	resultsFooter.appendChild(resultsFooterButton);
	resultsFooter.appendChild(resultsFooterArrow);
	resultsWrapper.appendChild(resultsFooter);

	search.resultsList = resultsWrapper;
	search.config.targetElement.appendChild(search.resultsList);

	search.hideLoader();

	removeTrapFocus(search.config.form);
	trapFocus(search.config.form);
};
// Create the loader markup
p80.predictiveSearch.prototype.generateLoader = function () {
	const search = this;

	const loaderWrapper = document.createElement('div');
	loaderWrapper.classList.add('predictive-search__loader');

	const loaderList = document.createElement('ul');
	loaderList.classList.add('predictive-search__list');

	const loaderListItem = document.createElement('li');
	loaderListItem.classList.add('predictive-search__item');

	const loaderSpinner = document.createElement('div');
	loaderSpinner.classList.add('predictive-search__spinner');

	loaderListItem.appendChild(loaderSpinner);
	loaderList.appendChild(loaderListItem);
	loaderWrapper.appendChild(loaderList);

	search.loader = loaderWrapper;
	search.config.targetElement.appendChild(search.loader);
};
// Reset our results list and delete from the dom
p80.predictiveSearch.prototype.removeResults = function () {
	const search = this;
	if (!search.resultsList) return;
	search.config.targetElement.removeChild(search.resultsList);
	search.resultsList = null;
};
// Show our loader
p80.predictiveSearch.prototype.showLoader = function () {
	const search = this;
	search.loader.classList.add('predictive-search__loader--active');
};
// Hide our loader
p80.predictiveSearch.prototype.hideLoader = function () {
	const search = this;
	search.loader.classList.remove('predictive-search__loader--active');
};
